import Vue from 'vue';
import App from './App.vue';
import '@/styles/global.css';
import navView from 'components/nav.vue';
import consultView from 'components/consult.vue';
import footerView from 'components/footer.vue';
import routers from './router'
import VueRouter from 'vue-router'
import toastRegistry from './components/toast/index'
import VueAMap from 'vue-amap';
Vue.use(VueRouter)
Vue.use(VueAMap);
Vue.use(toastRegistry)
Vue.component("navView", navView);
Vue.component("consultView", consultView);
Vue.component("footerView", footerView);
Vue.config.productionTip = false
const router =  new VueRouter({
  mode:'history',
  base: '/',
  routes:routers,
  scrollBehavior () {
    return {
      x:0,
      y:0
    }
  }
})
router.beforeEach((to, from, next) => {    
document.body.scrollTop = 0
document.documentElement.scrollTop = 0
window.pageYOffset = 0
next()
});
router.afterEach( ( to, from, next ) => {
  setTimeout(()=>{
          var _hmt = _hmt || [];
          (function() {
              //每次执行前，先移除上次插入的代码
              document.getElementById('baidu_tj') && document.getElementById('baidu_tj').remove();
              var hm = document.createElement("script");
              hm.src = "https://hm.baidu.com/hm.js?b3d0accf1f56d61e385dadd449e17f8b";
              hm.id = "baidu_tj"
              var s = document.getElementsByTagName("script")[0];
              s.parentNode.insertBefore(hm, s);
          })();
  },0);
});
VueAMap.initAMapApiLoader({
  key: 'nySite',
  plugin: [],
  // 默认高德 sdk 版本为 1.4.4
  v: '1.4.4'
});

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
